import React, { Component } from 'react';
import $ from "jquery";
import '../css/Toogle.css';
import { renderStandardTableCreate } from './renderStandardTableCreate';

const paginate = (array = [], pageSize = 10, pageNumber = 1) => { return array.slice((pageNumber - 1) * pageSize, pageNumber * pageSize) }

class StandardDataTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filteredData: null,
            pageNumber: 1,

            firstPage: false,
            previousPage: false,
            nextPage: false,
            lastPage: false,

            currentElements: 100,
        };
    }

    first = () => {
        const { pageSize, data } = this.props;
        const totalPage = data.length;

        this.setState({ 
            pageNumber: 1,
            firstPage: false,
            previousPage: false,
            nextPage: Number(totalPage || 0) / Number(pageSize || 10) > 1,
            lastPage: Number(totalPage || 0) / Number(pageSize || 10) > 1,
        });
    }

    previous = () => {
        const pageNumber = Number(this.state.pageNumber) - 1;

        this.setState({ 
            pageNumber: pageNumber,
            firstPage: pageNumber > 1,
            previousPage: pageNumber > 1,
            nextPage: true,
            lastPage: true,
        });
    }

    next = () => {
        const { pageSize, data } = this.props;
        const totalPage = data.length;

        let last = Math.ceil(Number(totalPage || 0) / Number(pageSize || 10));
        const pageNumber = Number(this.state.pageNumber) + 1;

        this.setState({ 
            pageNumber: pageNumber,
            firstPage: true,
            previousPage: true,
            nextPage: pageNumber < last,
            lastPage: pageNumber < last,
        });
    }

    last = () => {
        const { pageSize, data } = this.props;
        const totalPage = data.length;

        let last = Math.ceil(Number(totalPage || 0) / Number(pageSize || 10));
        this.setState({ 
            pageNumber: last,
            firstPage: true,
            previousPage: true,
            nextPage: false,
            lastPage: false,
        });
    }

    render() {
        const {
            data,
            searchBar,
            searchInTable,
            paginated = true,
            pageSize,
            
            selectionProps: { selectionList },
            tableProps: { selection },
        } = this.props;

        const {
            pageNumber,

            firstPage,
            previousPage,
            nextPage,
            lastPage,

            currentElements,
        } = this.state;

        const totalPage = data.length;
        const firstElement = totalPage > 0 ? ((pageNumber - 1) * (pageSize || 10)) + 1 : 0;
        const lastElement = (pageNumber * (pageSize || 10));

        const dataToShow = paginate(data, paginated ? pageSize : currentElements, paginated ? pageNumber : 1);
        
        const paginatedProps = {
            paginated,
            enableShowMore: currentElements < data.length,
            showMoreAction: () => {this.setState({currentElements: currentElements + 100})},
            enableShowLess: currentElements > 100,
            showLessAction: () => {this.setState({currentElements: currentElements - 100})},
        };

        return (
            <div>
                <div className="search-div row">
                    <div className="col-md-12" style={{ width: '100%' }}>
                        <input
                            id="searchStandardDataTable"
                            className='form-control btn-outline-secondary dropdown-toggle listSerie hide-pc'
                            style={{ display: 'inline-flex' }}
                            placeholder="Buscar"
                            autoComplete="off"
                            type="text"
                            value={searchBar || ''}
                            onChange={({target: {value}}) => searchInTable(value)} />
                    </div>
                </div>

                <div className="w-100 table-scroll table response">
                    {renderStandardTableCreate({ ...this.props, data: dataToShow, allData: data, paginatedProps})}
                </div>

                <div className="w-100 text-right">
                    {paginated ?
                        <div className="col-12">
                            <label className="col-form-label col-form-label-sm"> {firstElement} - {lastElement > totalPage ? totalPage : lastElement} de {totalPage} </label>

                            <button className="btn btn-link btn-sm text-dark" data-toggle="tooltip" data-placement="top" title="Primera" onClick={this.first} disabled={!firstPage}>
                                <i className="fas fa-chevron-left btn-first" />
                            </button>
                            <button className="btn btn-link btn-sm text-dark" data-toggle="tooltip" data-placement="top" title="Anterior" onClick={this.previous} disabled={!previousPage}>
                                <i className="fas fa-chevron-left" />
                            </button>
                            <label htmlFor="colFormLabelSm" className="col-form-label col-form-label-sm"> {pageNumber} </label>
                            <button className="btn btn-link btn-sm text-dark" data-toggle="tooltip" data-placement="top" title="Siguiente" onClick={this.next} disabled={!nextPage}>
                                <i className="fas fa-chevron-right" />
                            </button>
                            <button className="btn btn-link btn-sm text-dark" data-toggle="tooltip" data-placement="top" title="Última" onClick={this.last} disabled={!lastPage}>
                                <i className="fas fa-chevron-right btn-last" />
                            </button>
                        </div>
                        :
                        <div className="col-12">
                            <label className="px-2"> Elementos encontrados: {totalPage} </label>
                        </div>
                    }
                    {selection === "multiple" && <div className="col-12"><label className="px-2 mb-0"> Elementos seleccionados: {selectionList.length} </label></div>}
                </div>
            </div>
        );
    }
}
export default StandardDataTable;